:host {
  display: block;
  height: 100%;
  width: 100%;
}

#map {
  height: 100% !important;
  padding-bottom: 50%;
  position: relative;
  width: 100%;
}

